import { SelectedDamagedNamePoints } from '@/common/components/adjusterReport/damagedPoints/DamagedPartModal.type';
import { create } from 'zustand';

const useDamagedPoints = create<{
  damagedPoints: SelectedDamagedNamePoints[];
  addDamagedPoints: (newPoints: SelectedDamagedNamePoints[]) => void;
  removeDamagedPoint: (point: SelectedDamagedNamePoints) => void;
  updateDamagedPoints: (updatedPoints: SelectedDamagedNamePoints[]) => void;
  selectedSideName?: string;
  setSelectedSideName: (name: string) => void;
  resetDamagedPoints: () => void;
}>((set) => ({
  damagedPoints: [],
  setSelectedSideName: (name: string) =>
    set(() => ({
      selectedSideName: name,
    })),
  selectedSideName: '',
  addDamagedPoints: (newPoints: SelectedDamagedNamePoints[]) =>
    set((state) => {
      const updatedDamagedPoints = state.damagedPoints.filter((existingPoint) =>
        newPoints.some((newPoint) => newPoint.id === existingPoint.id),
      );
      updatedDamagedPoints.forEach((point) => {
        const index = state.damagedPoints.findIndex((p) => p.id === point.id);
        if (index !== -1) {
          state.damagedPoints.splice(index, 1);
        }
      });
      return {
        damagedPoints: [
          ...state.damagedPoints,
          ...newPoints.filter(
            (newPoint) =>
              !state.damagedPoints.some(
                (existingPoint) => existingPoint.id === newPoint.id,
              ),
          ),
        ],
      };
    }),

  removeDamagedPoint: (point: SelectedDamagedNamePoints) =>
    set((state) => ({
      damagedPoints: state.damagedPoints.filter((p) => p.id !== point.id),
    })),

  updateDamagedPoints: (updatedPoints: SelectedDamagedNamePoints[]) =>
    set(() => ({
      damagedPoints: updatedPoints,
    })),

  resetDamagedPoints: () =>
    set(() => ({
      damagedPoints: [],
    })),
}));
export default useDamagedPoints;
